import { Protected } from "@/components/layout/Protected";
import { Box, Grid, Container, Typography, IconButton, SelectChangeEvent, Autocomplete, Button,} from '@mui/material'
import {  useState } from "react";
import {Props} from "./ConsolidatePuchases.type";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import './ConsolidatedPurchases_styles.css'
import Modal from '@mui/material/Modal';
import { DataAbsence } from './TypeData/DataAbsence'
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import Stack from '@mui/material/Stack';
import { DataTardie } from "./TypeData/DataTardie";
import { ModalInforms } from "./Modal/ModalInforms";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface Column {
   id: 'numero' | 'rut' | 'apellidoPaterno' | 'apellidoMaterno'|'nombre';
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
 }

const columns:readonly Column[] = [
   { id: 'numero', label: 'N°', minWidth: 10 },
   { id: 'rut', label: 'Rut', minWidth: 10 },
   { id: 'apellidoPaterno', label: 'Apellido Paterno', minWidth: 10 },
   { id: 'apellidoMaterno', label: 'Apellido Materno', minWidth: 10 },
   { id: 'nombre', label: 'Nombre', minWidth: 10 },
   ];



const consolidadosMensuales=[
   {label:'Clasificacion de Compra',value:'Clasificacion de Compra'},
   {label:'Centro de Costo',value:'Centro de Costo'},
   {label:'Proveedor',value:'Proveedor'},
]

const consolidadosAnual=[
   {label:'Clasificacion de Compra',value:'Clasificacion de Compra'},
   {label:'Centro de Costo',value:'Centro de Costo'},
   {label:'Proveedor',value:'Proveedor'},
]

const comprasInternasMensuales=[
   {label:'SI',value:'SI'},
   {label:'NO',value:'NO'},
]


const comprasInternasAnual=[
   {label:'SI',value:'SI'},
   {label:'NO',value:'NO'},
]

export const ConsolidatePuchases:React.FC<Props> = (props: Props): JSX.Element => {
   const [value, setValue] = useState<Date | null>(new Date());
   const [openAbsense, setOpenAbsense] = useState(false);
   const [openTardie, setOpenTardie] = useState(false);
 

   const handleOpenAbsense = () => {
      setOpenAbsense(true);
      setOpenTardie(false);
   }
   const handleCloseAbsense = () => setOpenAbsense(false);

   const handleOpenTardie = () => {
      setOpenTardie(true);
      setOpenAbsense(false);
   }
   const handleCloseTardie = () => setOpenTardie(false);

  
    return (
        <Protected>
       <Container maxWidth='xl'>
           <Grid container spacing={3} mb={6}>
               <Grid item xs={12} md={12} >
                  <Box>
                     <Typography variant='h6' component='h1' gutterBottom className="tittle">
                        COMPRAS CONSOLIDADAS
                     </Typography>
                  </Box>
                  
               </Grid>
               <Grid item xs={12} sm={6}>
                  <Grid container spacing={3}>
                     <Grid item xs={12}>
                        <Typography variant='subtitle2'  gutterBottom  align="center" style={{background:'#ff9700', color:'#ffffff', borderRadius:'5px'}}  p={1}>
                           INFORMES MENSUALES
                        </Typography>
                     </Grid>
                     
                     <Grid item xs={12} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                           <Stack spacing={3}>
                              <DatePicker
                                    views={['year', 'month']}
                                    label="Periodo y Mes"
                                    minDate={new Date('2012-03-01')}
                                    maxDate={new Date('2023-06-01')}
                                    value={value}
                                    onChange={(newValue) => {
                                       setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField  {...params} helperText={null} />}
                                    />
                           </Stack>
                        </LocalizationProvider>
                     </Grid>
                     <Grid item xs={12} md={4}>
                           <Autocomplete
                           disablePortal
                           size='small'
                           id="combo-box-demo"
                           options={consolidadosMensuales}
                           renderInput={(params) => <TextField {...params} label="Consolidado por" />}
                        />
                     </Grid>
                     <Grid item xs={12} md={4}>
                           <Autocomplete
                           disablePortal
                           size='small'
                           id="combo-box-demo"
                           options={comprasInternasMensuales}
                           renderInput={(params) => <TextField {...params} label="Interno de Compras"/>}
                           />
                     </Grid>
                     <Grid item xs={12} md={9}>
                        <FormGroup>
                           <FormControlLabel control={<Checkbox defaultChecked />} label="Boleta Honorario" />
                           <FormControlLabel control={<Checkbox />} label="Comprobante Contable" />
                           <FormControlLabel control={<Checkbox />} label="Remuneraciones" />
                        </FormGroup>
                     </Grid>
                     
                     <Grid item xs={12} md={3}>
                        <Button
                           type='submit'
                           variant='contained'
                           onClick={handleOpenAbsense}
                           // disabled={loading}
                           disableElevation
                           className='btn_next'
                           style={{backgroundColor:'#16556b', color:'#fff'}}
                           >
                           <span>CONSULTAR</span>
                        </Button>
                     </Grid>
                  </Grid>
               </Grid>
               <Grid item xs={12} sm={6}>
                  <Grid container spacing={3}>
                     <Grid item xs={12}>
                        <Typography variant='subtitle2'  gutterBottom  align="center" style={{background:'#ff9700', color:'#ffffff', borderRadius:'5px'}}  p={1}>
                           INFORMES ANUALES
                        </Typography>
                     </Grid>
                     
                     <Grid item xs={12} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                           <Stack spacing={3}>
                              <DatePicker
                                    views={['year', 'month']}
                                    label="Periodo y Mes"
                                    // minDate={new Date('2012-03-01')}
                                    // maxDate={new Date('2023-06-01')}
                                    value={value}
                                    onChange={(newValue) => {
                                       setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField  {...params} helperText={null} />}
                                    />
                           </Stack>
                        </LocalizationProvider>
                     </Grid>
                     
                     <Grid item xs={12} md={4}>
                           <Autocomplete
                           disablePortal
                           size='small'
                           id="combo-box-demo"
                           options={consolidadosAnual}
                           renderInput={(params) => <TextField {...params} label="Consolidado por" />}
                        />
                     </Grid>
                     <Grid item xs={12} md={4}>
                           <Autocomplete
                           disablePortal
                           size='small'
                           id="combo-box-demo"
                           options={comprasInternasAnual}
                           renderInput={(params) => <TextField {...params} label="Interno de Compras"/>}
                           />
                     </Grid>

                     <Grid item xs={12} md={9}>
                        <FormGroup>
                           <FormControlLabel control={<Checkbox defaultChecked />} label="Boleta Honorario" />
                           <FormControlLabel control={<Checkbox />} label="Comprobante Contable" />
                           <FormControlLabel control={<Checkbox />} label="Remuneraciones" />
                        </FormGroup>
                     </Grid>

                     <Grid item xs={12} md={3}>
                        <Button
                           type='submit'
                           variant='contained'
                           onClick={handleOpenTardie}
                           // disabled={loading}
                           disableElevation
                           className='btn_next'
                           style={{backgroundColor:'#16556b', color:'#fff'}}
                           >
                           <span>CONTINUAR</span>
                        </Button>
                     </Grid>
                  </Grid>
               </Grid>
            </Grid>

            {openAbsense&&<DataAbsence entity={undefined} />||""}
               
            {openTardie && <DataTardie 
            entity={undefined}
            />||""}

         </Container>
         
     </Protected>
    );
   };